import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import APIS from "@service/api";
import { getUser } from "@utils";

export const documentManagementApi = createApi({
	reducerPath: "documentManagementApi",
	refetchOnFocus: false,
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: false,
	baseQuery: fetchBaseQuery({
		baseUrl: APIS["document-api"],
		prepareHeaders: (headers) => {
			const user = getUser();

			if (user?.token) {
				headers.set("Authorization", `Bearer=${user.token}`);
			}

			return headers;
		},
	}),
	endpoints: (builder) => ({
		getDocumentTypes: builder.query({
			query: () => ({
				url: "documentgroups",
				method: "GET",
			}),
			providesTags: ["DocumentTypes"],
		}),
		getAllDocuments: builder.query({
			query: () => ({
				url: "documents/user",
				method: "GET",
			}),
			providesTags: ["Documents"],
		}),
		getUploadUrl: builder.mutation({
			query: (data) => ({
				url: "file/upload",
				method: "POST",
				body: data,
			}),
		}),
		setDocumentPending: builder.mutation({
			query: ({ documentName, note = "", status = "Pending" }) => ({
				url: `documents/setpending/${encodeURI(documentName)}`,
				method: "POST",
				body: { note, status },
			}),
			invalidatesTags: ["Documents"],
		}),
		uploadS3: builder.mutation({
			query: ({ url, file }) => ({
				url: url,
				method: "PUT",
				body: file,
				headers: {
					"Content-Type": file.type,
				},
			}),
		}),
	}),
});

export const {
	useGetDocumentTypesQuery,
	useGetAllDocumentsQuery,
	useGetUploadUrlMutation,
	useSetDocumentPendingMutation,
	useUploadS3Mutation,
} = documentManagementApi;
